/* eslint react/no-unused-state: 0 */
import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';
import { setUserProfile } from '@Header/ducks/operations';
import { CoreEvent, eventNames } from '@carvana/core-events';
import { connect } from 'react-redux';
import ApplicationSettings from '../services/ApplicationSettings';
import Profile from './Profile';
import { signInStatus } from '../utilities/afterSignInSuccess';
import { closeCurrentModal } from '../Header/ducks/operations';

const CarvanaContext = createContext();
const CarvanaConsumer = CarvanaContext.Consumer;

class Provider extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    environment: PropTypes.string.isRequired,
    headerContext: PropTypes.shape({}).isRequired,
    isLoggedInExternally: PropTypes.bool,
    shouldRefreshProfile: PropTypes.bool,
    setUserProfile: PropTypes.func,
    closeModal: PropTypes.func
  };

  static defaultProps = {
    isLoggedInExternally: false,
    shouldRefreshProfile: false
  };

  constructor(props) {
    super(props);

    ApplicationSettings.setEnvironment(props.environment);

    this.state = {
      profile: {
        partner: {}
      },
      favorites: [],
      chatSettings: {},
      addFavorite: this.addFavorite,
      removeFavorite: this.removeFavorite
    };
  }

  componentDidMount() {
    this.getUserProfile();

    CoreEvent.on(eventNames.auth.change, user => {
      const { isLoggedIn } = user || {};
      if (isLoggedIn) {
        if (!signInStatus.isSignedIn()) this.getUserProfile();

        // check if query param has openAccountModal
        if (window.location.search.includes('openAccountModal')) {
          this.props.closeModal();
        }

        // check for return url and redirect
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = urlParams.get('returnUrl') ?? urlParams.get('ReturnUrl');
        if (returnUrl) {
          window.location.href = returnUrl;
        }
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isLoggedInExternally, shouldRefreshProfile, headerContext } = this.props;
    const { headerContext: prevHeaderContext } = prevProps;
    const { shouldRefreshProfile: headerContextShouldRefreshProfile } = headerContext;
    const { shouldRefreshProfile: prevHeaderContextShouldRefreshProfile } = prevHeaderContext;
    const isLoggedInExternallyDidChange = isLoggedInExternally && !prevProps.isLoggedInExternally;
    const shouldRefreshProfileDidChange =
      shouldRefreshProfile !== prevProps.shouldRefreshProfile ||
      headerContextShouldRefreshProfile !== prevHeaderContextShouldRefreshProfile;
    const shouldGetUserProfile = isLoggedInExternallyDidChange || shouldRefreshProfileDidChange;
    if (shouldGetUserProfile) {
      this.getUserProfile();
    }
  }

  // todo(oscar): trace down user profile and figure out if it can be moved into redux
  // why is this being passed down and where is it being called?
  getUserProfile = () => {
    Profile.getProfileFromServer().then(profile => {
      this.setState({ profile });
      this.props.setUserProfile(profile);
    });
  };

  render() {
    const { getUserProfile, state } = this;
    return (
      <CarvanaContext.Provider value={{ ...state, getUserProfile }}>{this.props.children}</CarvanaContext.Provider>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setUserProfile: profile => setUserProfile(profile)(dispatch),
  closeModal: () => dispatch(closeCurrentModal())
});

const connectedProvider = connect(null, mapDispatchToProps)(Provider);

export { connectedProvider as CarvanaProvider, CarvanaConsumer };
